export default __webpack_public_path__ + "f4f37382e76c62331f34cde81d353b64.png";